module.exports = __webpack_public_path__ + "img/icon_service@3x.3a4727ab.png";